import { render, staticRenderFns } from "./OCDetailsModal.vue?vue&type=template&id=5227648d"
import script from "./OCDetailsModal.vue?vue&type=script&lang=js"
export * from "./OCDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/InventoryLog/OCDetailsModal.vue
// module id = 2232
// module chunks = 31